import CargoCompanyAddressAddRequest, {
  CargoCompanyAddressAddRequestType,
} from "../../../../api/raily/cargo-company/address/add/cargo-company-address-add.request";
import CargoAddressType from "../../../../types/cargo-address-type";
import CargoCompanyAddressAddParams from "./cargo-company-address-add-params";

const createType = (
  type: CargoAddressType,
): CargoCompanyAddressAddRequestType => {
  switch (type) {
    case CargoAddressType.HOTEL:
      return CargoCompanyAddressAddRequestType.HOTEL;
    case CargoAddressType.MEETING_POINT:
      return CargoCompanyAddressAddRequestType.MEETING_POINT;
    case CargoAddressType.STATION:
      return CargoCompanyAddressAddRequestType.STATION;
  }
};

const create = (
  params: CargoCompanyAddressAddParams,
): CargoCompanyAddressAddRequest => {
  return {
    apartment: params.apartment,
    cargoCompanyUuid: params.cargoCompanyUuid,
    country: params.country,
    description: params.description,
    houseNo: params.houseNo,
    lat: params.lat,
    lon: params.lon,
    street: params.street,
    town: params.town,
    type: createType(params.type),
    zipCode: params.zipCode,
  };
};

const cargoCompanyAddressAddParamsFactory = {
  create,
};

export default cargoCompanyAddressAddParamsFactory;
